import React from "react";
import ExpandingBox from "components/ExpandingBox";
import Accordion from "components/Accordion";
import { connect } from "react-redux";
import { getAvailableProducts } from "state/app/selectors";
import "./HelpItem.css";

class HelpItem extends React.Component {
  
  state = {
    isExpanded: false
  }
  
  onExpand = () => {
    this.setState({ isExpanded: true });
  }
  onCollapse = () => {
    this.setState({ isExpanded: false });
  }
  
  // Show help item if user is registered to product.
  showHelpItem = (applications) => {
      
      let { availableProducts } = this.props;
      
      let find = (product) => {
        return(availableProducts.includes(product));
      }
      
      if(applications.find(find) === undefined){return false;}
      return true;
  }
  
  render() {
    const { title, applications, sections } = this.props;
    const { isExpanded } = this.state;
    const classNames = [ "help-item", isExpanded ? "help-item--expanded" : "help-item--collapsed" ];
      
    // If user isn't registered to product do not show them the products help items.  
    if(this.showHelpItem(applications) === false){return "";}  
      
    return (
      <div className={classNames.join(" ")}>
        <ExpandingBox expanded={isExpanded} onExpand={this.onExpand} onCollapse={this.onCollapse}>
          <ExpandingBox.Header>
            <div className="help-item__header">
              <div className="help-item__accent">
              { applications.map(application => (
                <div className={`help-item__accent-piece help-item__accent-piece--${application}`} />
              )) }
              </div>
              <div className="help-item__title">{title}</div>
            </div>
          </ExpandingBox.Header>
          <ExpandingBox.Body>
            <Accordion className="help-accordion">
              { sections.map(({ header, body }) => (  
                <Accordion.Section key={header}>
                  <Accordion.Section.Header>{header}</Accordion.Section.Header>
                  <Accordion.Section.Body>{body}</Accordion.Section.Body>
                </Accordion.Section>
              )) }
            </Accordion>
          </ExpandingBox.Body>
        </ExpandingBox>
      </div>
    )
  }
}

export default connect(
  state => ({
    availableProducts: getAvailableProducts(state)
  })
)(HelpItem)



// WEBPACK FOOTER //
// ./src/components/app/help/HelpItem.js